export enum CmsEntities {
    TEMPLATES = 'templates',
    RELEASES = 'releases',
    AI_ASSISTANT_SHORTCUTS = 'ai-assistant-shortcuts',
    EMOJI = 'emoji',
}
